import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid max-w-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-6 gap-x-4 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Key"),
  /*#__PURE__*/_createElementVNode("span", { class: "col-span-2" }, "Voice"),
  /*#__PURE__*/_createElementVNode("span", { class: "col-span-3" }, "Destination")
], -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "inline" }

import { computed, toRaw } from 'vue';
import { useToast } from 'vue-toastification';
import { required } from '@vuelidate/validators';
import {
	UiCardDivider,
	UiAudio,
	UiButton,
	UiForm,
	UiFormError,
	useForm,
	useLoading
} from '@/ui-kit';
import { uuid } from '@/utils';
import PhoneMenuItem from '../components/PhoneMenuItem.vue';
import PhoneDetailsPanel from './PhoneDetailsPanel.vue';
import PhoneMenuItemDialog from './PhoneMenuItemDialog.vue';
import { usePhoneNumberDetails } from '../composition/use-phone-number-details';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberPhoneMenu',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {





const toast = useToast();
const {
	updatePhoneMenu,
	phoneMenu,
	phoneNumberDetails,
	togglePhoneMenu,
	forwardingActive,
	phoneMenuActive
} = usePhoneNumberDetails();
// const { phoneMenu, updatePhoneNumber, togglePhoneMenu } = usePhoneNumbers();
const { loading: toggling, toggleLoading } =
	useLoading(false);
const {
	formData,
	onSubmit,
	fillFormData,
	isFormChanged,
	loading
} = useForm(
	{
		greetingVoiceMessage: null,
		menu: [] as any
	},
	{
		greetingVoiceMessage: {
			required
		},
		menu: {
			required
		}
	}
);

const isDisabled = computed(() => {
	return !isFormChanged({
		...phoneNumberDetails.value,
		menu: phoneMenu.value
	});
});

const triggerTogglePhoneMenu = async () => {
	emit('loading', true);
	toggleLoading(true);
	await togglePhoneMenu(
		phoneMenuActive.value ? 0 : 1
	).finally(() => {
		toggleLoading(false);
		emit('loading', false);
	});
	toast.success(
		`Phone menu was ${
			phoneMenuActive.value
				? 'activated'
				: 'deactivated'
		}.`
	);
};

const addOption = () => {
	formData.menu.push({
		id: uuid(5),
		key: '',
		voice: '',
		destination: '',
		type: 3
	});
};

const removeItem = (idx: number) => {
	formData.menu = formData.menu.filter(
		(item: any, i: number) => i !== idx
	);
};

const fillForm = () => {
	fillFormData({
		...phoneNumberDetails.value,
		menu: phoneMenu.value
	});
};

const submit = onSubmit(async (data) => {
	emit('loading', true);
	await updatePhoneMenu({
		...data,
		menu: toRaw(data.menu).slice()
	}).finally(() => {
		emit('loading', false);
	});
	fillForm();
});

fillForm();

return (_ctx: any,_cache: any) => {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createBlock(PhoneDetailsPanel, {
    title: "Phone menu",
    subTitle: "Design a phone menu controlled by keypad and voice.",
    isActive: _unref(phoneMenuActive),
    loading: _unref(toggling),
    disabled: _unref(toggling) || _unref(forwardingActive) || __props.disabled,
    class: _normalizeClass({
			'opacity-50 cursor-not-allowed':
				_unref(forwardingActive)
		}),
    onToggle: triggerTogglePhoneMenu
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(UiForm), {
        class: "relative",
        onSubmit: _unref(submit)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(UiCardDivider), {
            title: "Greeting message",
            subtitle: "Example: Hi! Thanks for calling. For sales, press 1 for sales. For support, press 2 for support."
          }),
          _createVNode(_unref(UiAudio), {
            disabled: 
					!_unref(phoneMenuActive) ||
					_unref(toggling) ||
					_unref(loading) ||
					_unref(forwardingActive) ||
					__props.disabled
				,
            modelValue: _unref(formData).greetingVoiceMessage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).greetingVoiceMessage) = $event)),
            name: "greetingVoiceMessage",
            noRemove: "",
            class: "mb-4"
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(_unref(UiCardDivider), {
            title: "Menu options",
            subtitle: "Options are triggered by keypad and voice commands and they route callers to other phone numbers in your workspace"
          }),
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).menu, (item, i) => {
              return (_openBlock(), _createBlock(PhoneMenuItem, {
                key: item.id,
                modelValue: _unref(formData).menu[i],
                "onUpdate:modelValue": ($event: any) => ((_unref(formData).menu[i]) = $event),
                disabled: 
						!_unref(phoneMenuActive) ||
						_unref(toggling) ||
						_unref(loading) ||
						_unref(forwardingActive) ||
						__props.disabled
					,
                otherItems: _unref(formData).menu,
                onRemoveItem: ($event: any) => (removeItem(i))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "otherItems", "onRemoveItem"]))
            }), 128)),
            _createVNode(_unref(UiFormError), {
              name: "menu",
              label: "Menu"
            }),
            _createElementVNode("div", _hoisted_3, [
              (_unref(formData).menu.length < 10)
                ? (_openBlock(), _createBlock(_unref(UiButton), {
                    key: 0,
                    icon: "plus",
                    type: "button",
                    theme: "primary-outlined",
                    class: "!h-10",
                    onClick: addOption,
                    disabled: 
							!_unref(phoneMenuActive) ||
							_unref(toggling) ||
							_unref(loading) ||
							_unref(forwardingActive) ||
							__props.disabled
						
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Add another option")
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_unref(UiCardDivider), { title: "If no option selected, repeat the menu options" }),
          _createVNode(_component_ElTooltip, {
            disabled: 
					(!_unref(isDisabled) && !_unref(forwardingActive)) ||
					__props.disabled
				,
            "show-after": 500,
            "hide-after": 0,
            enterable: false,
            placement: "left",
            content: "You have no changes to save"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(UiButton), {
                  class: "!h-10 !min-w-24",
                  disabled: 
							_unref(isDisabled) ||
							_unref(toggling) ||
							!_unref(phoneMenuActive) ||
							_unref(forwardingActive) ||
							__props.disabled
						,
                  loading: _unref(loading)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save Changes")
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      _createVNode(PhoneMenuItemDialog, { ref: "dialog" }, null, 512)
    ]),
    _: 1
  }, 8, ["isActive", "loading", "disabled", "class"]))
}
}

})